import RequestMaster from '../RequestMaster'

export default class RequestGrupoEmpleado extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/grupo-empleado'
    }
}
